var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.646 20.9996H18.316C18.882 21.0096 19.4319 20.8115 19.8614 20.4428C20.291 20.0741 20.5702 19.5606 20.646 18.9996V11.9996C20.5702 11.4387 20.291 10.9251 19.8614 10.5565C19.4319 10.1878 18.882 9.98963 18.316 9.99964H15.646M8.64603 3.99964V3.99964C8.64603 6.20878 6.85517 7.99964 4.64603 7.99964H2.98603C2.69612 7.99636 2.40896 8.05614 2.14445 8.17486C1.87995 8.29357 1.64441 8.46837 1.45417 8.68715C1.26392 8.90593 1.12352 9.16346 1.04269 9.44189C0.961852 9.72032 0.942519 10.013 0.986026 10.2996L2.36603 19.2996C2.43835 19.7765 2.68059 20.2112 3.04812 20.5236C3.41565 20.836 3.8837 21.0051 4.36603 20.9996H7.64603C12.0643 20.9996 15.646 17.4179 15.646 12.9996V11.6974C15.646 10.578 15.4111 9.47112 14.9565 8.44824L12.6029 3.15271C12.021 1.84342 10.5378 0.865194 9.52471 1.87832V1.87832C8.9621 2.44093 8.64603 3.20399 8.64603 3.99964Z",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.223106f76452d9adc35d5cd42d86c498.svg";
export { ForwardRef as ReactComponent };